import { render } from "./CommBest_side.vue?vue&type=template&id=0ef199fb"
import script from "./CommBest_side.vue?vue&type=script&lang=js"
export * from "./CommBest_side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__